import React, { useEffect, useState } from "react";
import { Chip, Box, Avatar, TableCell, TextField, Typography, useTheme, Stack, Tooltip } from "@mui/material"
import { TableRow } from "@mui/material"
import { Product } from "@domain/product/models/Product";
import { APP_CONFIG } from "../../../../config/app.config";


interface WarehouseInventoryCountRowProps {
    product: Product
    quantity?: number
    handleQuantityChange: (productId: string, quantity?: number) => void
}


const WarehouseInventoryCountRow = ({ product, quantity, handleQuantityChange }: WarehouseInventoryCountRowProps) => {

    const theme = useTheme();

    const [mutatedQuantity, setMutatedQuantity] = useState<number | undefined>();


    const handleMutatedQuantityChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setMutatedQuantity(e.target.value ? parseInt(e.target.value) : undefined);
        handleQuantityChange(product.id, e.target.value ? parseInt(e.target.value) : undefined);
    }


    const formatQuantity = (mutatedQuantity?: number) => {
        if (mutatedQuantity === undefined) {
            return '-';
        }

        const diff = (mutatedQuantity || 0) - (quantity || 0);
        return (diff > 0 ? '+' : '') + new Intl.NumberFormat('nl-NL').format(diff);
    }

    return (
        <TableRow key={product.id}>
            <TableCell sx={{ display: 'flex', alignItems: 'center', height: 60, gap: 2, border: 0, borderRight: 1, borderColor: theme.palette.divider, py: 2, px: 3 }}>

                <Avatar sx={{ width: 40, height: 40, borderRadius: 1, border: 1, borderColor: theme.palette.divider }} src={product.image} />

                <Tooltip title={product.title}>
                    <Stack direction="column" spacing={0} flexGrow={1} justifyContent="center">
                        <Typography
                            sx={{ display: '-webkit-box', WebkitLineClamp: 1, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}

                            color={theme.palette.text.primary} fontSize={14}> {product.title} </Typography>


                        <Stack direction="row" spacing={1}>
                            {product.ean && <Typography fontSize={12} color={theme.palette.text.secondary}> {'EAN: ' + product.ean} </Typography>}
                            {product.sku && <Typography fontSize={12} color={theme.palette.text.secondary}> {'SKU: ' + product.sku} </Typography>}
                        </Stack>
                    </Stack>
                </Tooltip>


            </TableCell >

            <TableCell align="right" sx={{ backgroundColor: APP_CONFIG.ui.theme.colors.backgroundTint, width: 50, py: 2, px: 3 }}>
                <Typography color={APP_CONFIG.ui.theme.colors.secondaryText}> {quantity || '-'} </Typography>
            </TableCell>

            <TableCell align="right" sx={{ border: 0, borderLeft: 1, borderColor: theme.palette.divider, py: 2, px: 3 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>



                    <TextField
                        type="number"
                        placeholder="0"
                        value={mutatedQuantity ?? ''}
                        onChange={handleMutatedQuantityChange}
                    />

                    <Chip
                        sx={{ width: 80, backgroundColor: APP_CONFIG.ui.theme.colors.primaryTint, color: APP_CONFIG.ui.theme.colors.primary }}
                        label={formatQuantity(mutatedQuantity)}
                    />
                </Box>
            </TableCell>
        </TableRow >
    );
};

export default WarehouseInventoryCountRow;